import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";
import "./styles/tailwind.css";
import "./styles/index.css";

// Ensure unhandled promise rejections always have a proper Error object
// This prevents platform scripts from crashing when reading error properties
window.addEventListener('unhandledrejection', (event) => {
  if (event?.reason === undefined || event?.reason === null) {
    event?.preventDefault();
    console.warn('[App] Suppressed unhandled rejection with undefined reason');
  } else if (typeof event?.reason !== 'object') {
    // Convert primitive rejection values to Error objects
    const err = new Error(String(event.reason));
    console.warn('[App] Converted primitive rejection to Error:', err?.message);
  }
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <ThemeProvider>
    <AuthProvider>
      <App />
    </AuthProvider>
  </ThemeProvider>
);
